// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAlhhE1TFgLq7XmaHIZZnO9p8_niD8vt5o",
  authDomain: "computer-parts-manufactu-d3e00.firebaseapp.com",
  projectId: "computer-parts-manufactu-d3e00",
  storageBucket: "computer-parts-manufactu-d3e00.appspot.com",
  messagingSenderId: "470312863209",
  appId: "1:470312863209:web:9446de45d43c1c8a6b3778"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;